var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded shadow-sm min-h-32 border p-4 mb-4 knowledge-list",on:{"click":_vm.redirectToArticle}},[_c('div',{staticClass:"knowledge-list-heading"},[_vm._v(_vm._s(_vm.article.title))]),_c('div',{staticClass:"knowledge-list-content",domProps:{"innerHTML":_vm._f("truncate")(_vm.article.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }